exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab{width:75px;text-align:center;font-size:14px;line-height:20px;font-weight:300;text-decoration:none;color:#333}.tab .tab-icon-container{border-radius:50%;height:60px;width:60px;margin:0 auto;background:#fff;box-shadow:0 3px 16px -9px #0056cc;display:flex;justify-content:center;overflow:hidden;align-items:center;margin-bottom:6px}.tab .tab-icon-container .tab-icon{height:35px;width:35px}@media only screen and (max-width:320px){.tab{width:60px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js?outputStyle=expanded!./src/styles/TabIcon.scss
// module id = 913
// module chunks = 0